import { ClientConfig } from "../app/clientConfig";
import client from "./client";

export const getClientConfig = (clientId: string) =>
  client.get<ClientConfig>(`/app-config/${clientId}`).then(({ data }) => data);
